import React, { Fragment } from 'react';
import './Loading.css';
import loader from '../../assets/images/feather-loader.svg';

const Loading = props => {
    return(
        <Fragment>
            <div className="loading">
                {/* Image */}
                <div className="loader-content">
                    <img src={loader} className="loader" />
                </div>
            </div>
        </Fragment>
    )
}

export default Loading;